
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "customer-portal-app",
  currentProjectVersion: "static-1.3408",
  depVersions: {
  "customer-portal-app": "static-1.3408",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.510",
  "data-fetching-client": "static-1.10115",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26501",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6067",
  "hs-test-utils": "static-1.8513",
  "hub-http": "static-1.6681",
  "hub-http-shared-msw-handlers": "static-1.10903",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19280",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11962",
  "I18n": "static-7.1708",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6926",
  "payment-link-components": "static-1.24456",
  "portals-platform-bend-plugin": "static-1.26",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7659",
  "quartz-core": "static-1.6878",
  "quartz-i18n": "static-1.1334",
  "react": "static-7.202",
  "react-colorpicker": "static-2.10684",
  "react-dlb": "static-1.93",
  "react-utils": "static-2.5657",
  "reselect": "static-3.16",
  "rich-text-lib": "static-1.20555",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18547",
  "ui-components-test-utils": "static-1.6099",
  "UIComponents": "static-3.8908",
  "video-player-core": "static-1.21",
  "foundations-assets": "static-1.5360",
  "foundations-components": "static-1.8749",
  "foundations-theming": "static-1.4962",
  "foundations-theming-specialty": "static-1.2678",
  "framer-motion": "static-1.84",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1699",
  "quartz-config": "static-1.1437",
  "quartz-routing": "static-1.1089",
  "quick-fetch": "static-1.4231",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17209",
  "rpc-client-utils": "static-1.5144",
  "sanitize-text": "static-1.8632",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.66",
  "ui-addon-draggable": "static-3.5223",
  "ui-addon-react-router-dom": "static-1.10001",
  "usage-tracker": "static-1.7798",
  "usage-tracker-anonymous": "static-1.6215",
  "usage-tracker-core": "static-1.7648",
  "video-components-external": "static-1.12430",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3936",
  "quartz-webpack": "static-1.3883",
  "bend-plugin-quartz-routing": "static-1.737",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.93",
  "customer-data-objects": "static-1.8177",
  "frontend-preferences-client": "static-1.8395",
  "laboratory-lib": "static-3.7621",
  "onboarding-scopes": "static-1.6927",
  "seat-types-lib": "static-1.1050",
  "ui-addon-opt": "static-4.8881",
  "HeadJS": "static-2.822",
  "hs-test-utils-bend-plugin": "static-1.3624",
  "msw": "static-1.102",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.401",
  "ts-schema": "static-1.4393",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8423",
  "content-media-capture": "static-1.5788",
  "cssUtils": "static-1.1097",
  "customer-data-ui-utilities": "static-1.10308",
  "file-manager-components": "static-1.24842",
  "HubStyle": "static-2.12269",
  "knowledge-content-types": "static-1.8763",
  "PatternValidationJS": "static-1.3359",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.518",
  "ui-addon-emoji-picker": "static-1.10338",
  "ui-addon-i18n": "static-1.11620",
  "ui-business-units-lib": "static-1.9570",
  "ui-shepherd-react": "static-3.10753",
  "video-data-lib": "static-1.36088",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4782",
  "commerce-tours-lib": "static-1.6863",
  "customer-data-properties": "static-1.53042",
  "getting-started-shared-tasks": "static-1.19562",
  "growth-onboarding-reliability": "static-1.5558",
  "onboarding-tours": "static-1.17405",
  "reference-resolvers-lite": "static-1.8585",
  "sales-checkout-service-client": "static-1.3999",
  "ui-addon-iframeable": "static-1.9549",
  "user-context": "static-1.5528",
  "bender-build-tools": "static-1.3582",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4976",
  "icons": "static-2.702",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.641",
  "quartz-auth": "static-1.1334",
  "quartz-head": "static-1.1324",
  "quartz-test": "static-1.1334",
  "quartz-tracking": "static-1.1038",
  "trellis-components": "static-1.3106",
  "ui-fonts": "static-1.1224",
  "usage-tracker-container": "static-1.7788",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9899",
  "data-token-picker": "static-1.17135",
  "FileManagerLib": "static-1.40482",
  "property-translator": "static-1.5854",
  "merchandise-lib": "static-1.284",
  "purchase-motions-components": "static-1.6631",
  "SharedI18nStrings": "static-1.187",
  "foundations-components-test-utils": "static-1.6232",
  "react-create-root-preference": "static-1.103",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "ui-images": "static-2.1276",
  "bend-plugin-foundations-components": "static-1.5018",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "trellis-assets": "static-1.3087",
  "bend-plugin-foundations-theming": "static-1.3445",
  "foundations-theming-base": "static-1.3947",
  "stylex": "static-1.46",
  "interframe": "static-3.5215",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6212",
  "opentelemetry-fe-types": "static-1.266",
  "beacon-keepalive-queue": "static-1.175",
  "web-vitals": "static-1.19",
  "bend-plugin-chirp-manifest": "static-1.554",
  "chirp-fetch": "static-1.2379",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4949",
  "react-flip-move": "static-1.83",
  "apollo-link-hub-http": "static-2.5062",
  "content-media-composition-data-lib": "static-1.13592",
  "content-media-compositions": "static-2.17599",
  "idb-keyval": "static-1.55",
  "immer": "static-1.105",
  "immerable": "static-1.4616",
  "magpie-lib": "static-1.5907",
  "magpie-types": "static-1.5367",
  "media-bridge-lib": "static-1.19643",
  "inbound-db-properties-service-client": "static-1.4152",
  "superstore": "static-1.5234",
  "feedback-loader": "static-1.30062",
  "ai-components-ui-library": "static-1.10018",
  "ui-addon-video-player": "static-1.9098",
  "ui-coaching-tips": "static-1.29583",
  "ContentUtils": "static-1.69473",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4901",
  "sassPrefix": "static-1.363",
  "react-dnd-compat": "static-1.5084",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2180",
  "copilot-toolkit": "static-1.12148",
  "poll-commands": "static-1.3952",
  "atom": "static-1.5547",
  "avatar-components": "static-1.2962",
  "navigation-messaging": "static-1.8494",
  "redux-thunk": "static-2.84",
  "reference-resolvers": "static-1.8658",
  "commerce-products-lib": "static-1.10917",
  "crm-message-bus": "static-1.44105",
  "growth-data-modal": "static-1.6134",
  "hubspot-apollo-client": "static-1.5355",
  "onboarding-tours-client": "static-1.5620",
  "batch-promise": "static-1.2022",
  "calling-global-api": "static-1.66189",
  "calling-internal-common": "static-1.31800",
  "calling-lifecycle-internal": "static-1.67571",
  "calling-lifecycle-messages": "static-1.59864",
  "conditional-properties-service-client": "static-1.4114",
  "crm-index-visualization-core": "static-1.4756",
  "crm-links": "static-1.6783",
  "crm-pipelines-api-client-types": "static-1.4444",
  "customer-data-objects-ui-components": "static-1.13510",
  "customer-data-properties-shared-msw-handlers": "static-1.10230",
  "customer-data-property-utils": "static-1.8525",
  "external-options-client-types": "static-1.4440",
  "formula-editor": "static-1.15012",
  "google-libphonenumber": "static-1.49",
  "hs-resources": "static-1.667",
  "inbound-db-meta-service-client": "static-1.3775",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1108",
  "multi-currency-client-types": "static-1.4008",
  "object-builder-ui-client": "static-1.50047",
  "pipeline-validation-client-types": "static-1.4282",
  "property-value-citations": "static-1.3656",
  "pulse": "static-1.1121",
  "smart-data-capture-core": "static-1.473",
  "smart-property-lib": "static-1.8654",
  "tiered-pricing": "static-1.2274",
  "topics-actions-lib": "static-1.658",
  "trellis-ext-i18n": "static-1.1389",
  "trellis-theming": "static-1.1479",
  "trial-components-library": "static-1.14376",
  "ui-addon-form-validation": "static-1.11348",
  "zustand": "static-1.89",
  "growth-onboarding-confetti": "static-1.3533",
  "growth-onboarding-next-action-utils": "static-1.2984",
  "navigation-components": "static-1.19167",
  "nest": "static-1.709",
  "onboarding-tours-utils": "static-1.1472",
  "ui-shepherd-tracker": "static-1.8134",
  "ui-universal-auth": "static-1.9744",
  "getting-started-shared-tasks-store": "static-1.18680",
  "opentelemetry-web": "static-1.22",
  "hubspotter-http-shared-msw-handlers": "static-1.10901",
  "usage-tracker-session-replay": "static-1.5484",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "audio-components": "static-1.6571",
  "FileManagerCore": "static-1.40341",
  "FileManagerImages": "static-1.37993",
  "video-components": "static-1.14432",
  "foundations-components-legacy": "static-1.1774",
  "purchase-motions-api": "static-1.6634",
  "signup-constants": "static-1.19943",
  "signup-ui-url-generator": "static-2.8520",
  "stylex-utils": "static-1.175",
  "usage-tracker-public": "static-1.7609",
  "reactive-lib": "static-1.1193",
  "simple-logging-lib": "static-1.3525",
  "nudge-client-utils": "static-1.3420",
  "chatspot-core": "static-1.23884",
  "growth-onboarding-feedback-components": "static-1.7057",
  "cms-field-types": "static-1.5285",
  "content-icons-ui": "static-1.2456",
  "integrations-lib": "static-1.17430",
  "underscore": "static-1.8",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1158",
  "breeze-engine-core": "static-1.1458",
  "highlight.js": "static-1.90",
  "markdown-it": "static-1.6",
  "trellis-migration-context": "static-1.54",
  "nav-meta": "static-1.30804",
  "commerce-permissions": "static-1.1259",
  "customer-data-tracking": "static-1.7344",
  "products-iframe-lib": "static-1.8907",
  "products-ui-components-shared-msw-handlers": "static-1.11285",
  "restore-request-side-panel-lib": "static-1.2034",
  "onboarding-data-sync-lib": "static-1.2840",
  "hubspot-apollo-cache": "static-1.814",
  "calling-error-reporting": "static-1.31807",
  "shared-worker-versioning": "static-1.11515",
  "calling-usage-tracker": "static-1.7013",
  "conversations-skeleton-state": "static-1.7608",
  "voice-sms-access-library": "static-1.2442",
  "crm-index-associations-lib": "static-1.6923",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10986",
  "redux-toolkit": "static-1.82",
  "sales-views-client-types": "static-1.4731",
  "framework-data-schema-resolvers": "static-1.7366",
  "location-customization-utils-lib": "static-1.10419",
  "bark-lib": "static-1.17005",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6369",
  "react-codemirror": "static-1.11116",
  "event-emitter": "static-1.1436",
  "fdsr-migration-layer": "static-1.485",
  "framework-builder-read-service-client": "static-1.4335",
  "bend-plugin-pulse": "static-1.624",
  "fast-json-patch": "static-1.74",
  "data-agent-kit": "static-1.916",
  "data-agent-test-utils": "static-1.460",
  "data-agent-utils": "static-1.929",
  "fsm": "static-1.4232",
  "policy-lib": "static-1.7282",
  "react-tinymce": "static-1.56270",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11049",
  "tinymce-config": "static-2.55396",
  "tinymce-plugins": "static-1.58510",
  "embedded-academy-lib": "static-1.16005",
  "hubs-service-types": "static-1.1742",
  "salesImages": "static-1.732",
  "growth-onboarding-next-action-components": "static-1.3012",
  "user-context-client": "static-1.4984",
  "custom-vendor-connection-lib": "static-1.308",
  "unified-auth-core-lib": "static-1.1540",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.948",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4989",
  "video-embed": "static-1.36922",
  "social-insights-client-types": "static-1.22930",
  "nudge-custom-function-registry": "static-1.3177",
  "nudge-renderer-utils": "static-1.3496",
  "whisper-core-api": "static-1.7636",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14845",
  "integrations-tracking-lib": "static-1.6094",
  "native-integrations-shared-strings": "static-1.8238",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10845",
  "rxjs": "static-5.10",
  "InboxConnectUtils": "static-4.15844",
  "meetings-connect-utils-lib": "static-1.8093",
  "calling-orchestration-schema": "static-1.37219",
  "framework-data-schema-quick-fetch": "static-1.7271",
  "persist-promise": "static-1.4179",
  "crm-record-cards-service-types": "static-1.3871",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16669",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "trellis-story-utils": "static-1.4972",
  "enrichment-settings-lib": "static-1.234",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57366",
  "hub-http-contrib": "static-1.3506",
  "tinymce-data": "static-1.41481",
  "ui-addon-sales-email": "static-1.5676",
  "layout-dnd-components": "static-1.13229",
  "layout-dnd-utils": "static-1.12204",
  "ui-brand-identity-lib": "static-1.16946",
  "academy-common-lib": "static-1.15466",
  "outpost": "static-1.4602",
  "universal-page-editor-lib": "static-1.3484",
  "NamespacedHubStyle": "static-2.9367",
  "ContentData": "static-1.69548",
  "layout-data-lib": "static-1.10529",
  "academy-service-client": "static-1.4166",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4871",
  "trellis-ecosystem": "static-1.7849",
  "wootric-nps": "static-1.7297",
  "advanced-menus-core": "static-1.15816",
  "advanced-menus-lib": "static-1.12569",
  "ExportDialog": "static-6.10849",
  "ui-memberships-settings-lib": "static-1.35192",
  "marketplace-ui-apps-core": "static-1.19582",
  "marketplace-ui-common": "static-1.21050",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15815",
  "simple-menus-lib": "static-1.17332",
  "settings-ui-lib": "static-1.13001",
  "developer-experience-shared-components": "static-1.11013",
  "immutable-less": "static-1.5127",
  "marketplace-ui-client-types": "static-1.18457",
  "ui-addon-integrations-directory-panel": "static-2.8427",
  "ui-extensibility-client-types": "static-1.4390",
  "ai-settings-ui-library": "static-1.8582",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1580",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4612",
  "simple-data-table": "static-1.3822"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3408",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.510",
  "data-fetching-client": "/data-fetching-client/static-1.10115",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26501",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6067",
  "hs-test-utils": "/hs-test-utils/static-1.8513",
  "hub-http": "/hub-http/static-1.6681",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10903",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19280",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11962",
  "I18n": "/I18n/static-7.1708",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6926",
  "payment-link-components": "/payment-link-components/static-1.24456",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.26",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7659",
  "quartz-core": "/quartz-core/static-1.6878",
  "quartz-i18n": "/quartz-i18n/static-1.1334",
  "react": "/react/static-7.202",
  "react-colorpicker": "/react-colorpicker/static-2.10684",
  "react-dlb": "/react-dlb/static-1.93",
  "react-utils": "/react-utils/static-2.5657",
  "reselect": "/reselect/static-3.16",
  "rich-text-lib": "/rich-text-lib/static-1.20555",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6099",
  "UIComponents": "/UIComponents/static-3.8908",
  "video-player-core": "/video-player-core/static-1.21",
  "foundations-assets": "/foundations-assets/static-1.5360",
  "foundations-components": "/foundations-components/static-1.8749",
  "foundations-theming": "/foundations-theming/static-1.4962",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2678",
  "framer-motion": "/framer-motion/static-1.84",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1699",
  "quartz-config": "/quartz-config/static-1.1437",
  "quartz-routing": "/quartz-routing/static-1.1089",
  "quick-fetch": "/quick-fetch/static-1.4231",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17209",
  "rpc-client-utils": "/rpc-client-utils/static-1.5144",
  "sanitize-text": "/sanitize-text/static-1.8632",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.66",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5223",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10001",
  "usage-tracker": "/usage-tracker/static-1.7798",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6215",
  "usage-tracker-core": "/usage-tracker-core/static-1.7648",
  "video-components-external": "/video-components-external/static-1.12430",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3936",
  "quartz-webpack": "/quartz-webpack/static-1.3883",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.737",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.93",
  "customer-data-objects": "/customer-data-objects/static-1.8177",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8395",
  "laboratory-lib": "/laboratory-lib/static-3.7621",
  "onboarding-scopes": "/onboarding-scopes/static-1.6927",
  "seat-types-lib": "/seat-types-lib/static-1.1050",
  "ui-addon-opt": "/ui-addon-opt/static-4.8881",
  "HeadJS": "/HeadJS/static-2.822",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3624",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.401",
  "ts-schema": "/ts-schema/static-1.4393",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8423",
  "content-media-capture": "/content-media-capture/static-1.5788",
  "cssUtils": "/cssUtils/static-1.1097",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10308",
  "file-manager-components": "/file-manager-components/static-1.24842",
  "HubStyle": "/HubStyle/static-2.12269",
  "knowledge-content-types": "/knowledge-content-types/static-1.8763",
  "PatternValidationJS": "/PatternValidationJS/static-1.3359",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10338",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11620",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9570",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10753",
  "video-data-lib": "/video-data-lib/static-1.36088",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4782",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6863",
  "customer-data-properties": "/customer-data-properties/static-1.53042",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19562",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5558",
  "onboarding-tours": "/onboarding-tours/static-1.17405",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8585",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3999",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9549",
  "user-context": "/user-context/static-1.5528",
  "bender-build-tools": "/bender-build-tools/static-1.3582",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4976",
  "icons": "/icons/static-2.702",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.641",
  "quartz-auth": "/quartz-auth/static-1.1334",
  "quartz-head": "/quartz-head/static-1.1324",
  "quartz-test": "/quartz-test/static-1.1334",
  "quartz-tracking": "/quartz-tracking/static-1.1038",
  "trellis-components": "/trellis-components/static-1.3106",
  "ui-fonts": "/ui-fonts/static-1.1224",
  "usage-tracker-container": "/usage-tracker-container/static-1.7788",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9899",
  "data-token-picker": "/data-token-picker/static-1.17135",
  "FileManagerLib": "/FileManagerLib/static-1.40482",
  "property-translator": "/property-translator/static-1.5854",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "purchase-motions-components": "/purchase-motions-components/static-1.6631",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6232",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "ui-images": "/ui-images/static-2.1276",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5018",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "trellis-assets": "/trellis-assets/static-1.3087",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3445",
  "foundations-theming-base": "/foundations-theming-base/static-1.3947",
  "stylex": "/stylex/static-1.46",
  "interframe": "/interframe/static-3.5215",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6212",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.266",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.175",
  "web-vitals": "/web-vitals/static-1.19",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.554",
  "chirp-fetch": "/chirp-fetch/static-1.2379",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4949",
  "react-flip-move": "/react-flip-move/static-1.83",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5062",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13592",
  "content-media-compositions": "/content-media-compositions/static-2.17599",
  "idb-keyval": "/idb-keyval/static-1.55",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4616",
  "magpie-lib": "/magpie-lib/static-1.5907",
  "magpie-types": "/magpie-types/static-1.5367",
  "media-bridge-lib": "/media-bridge-lib/static-1.19643",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4152",
  "superstore": "/superstore/static-1.5234",
  "feedback-loader": "/feedback-loader/static-1.30062",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10018",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9098",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29583",
  "ContentUtils": "/ContentUtils/static-1.69473",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4901",
  "sassPrefix": "/sassPrefix/static-1.363",
  "react-dnd-compat": "/react-dnd-compat/static-1.5084",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2180",
  "copilot-toolkit": "/copilot-toolkit/static-1.12148",
  "poll-commands": "/poll-commands/static-1.3952",
  "atom": "/atom/static-1.5547",
  "avatar-components": "/avatar-components/static-1.2962",
  "navigation-messaging": "/navigation-messaging/static-1.8494",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reference-resolvers": "/reference-resolvers/static-1.8658",
  "commerce-products-lib": "/commerce-products-lib/static-1.10917",
  "crm-message-bus": "/crm-message-bus/static-1.44105",
  "growth-data-modal": "/growth-data-modal/static-1.6134",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5355",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5620",
  "batch-promise": "/batch-promise/static-1.2022",
  "calling-global-api": "/calling-global-api/static-1.66189",
  "calling-internal-common": "/calling-internal-common/static-1.31800",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67571",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59864",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4114",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4756",
  "crm-links": "/crm-links/static-1.6783",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4444",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13510",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10230",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8525",
  "external-options-client-types": "/external-options-client-types/static-1.4440",
  "formula-editor": "/formula-editor/static-1.15012",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "hs-resources": "/hs-resources/static-1.667",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3775",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1108",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4008",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50047",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4282",
  "property-value-citations": "/property-value-citations/static-1.3656",
  "pulse": "/pulse/static-1.1121",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.473",
  "smart-property-lib": "/smart-property-lib/static-1.8654",
  "tiered-pricing": "/tiered-pricing/static-1.2274",
  "topics-actions-lib": "/topics-actions-lib/static-1.658",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1389",
  "trellis-theming": "/trellis-theming/static-1.1479",
  "trial-components-library": "/trial-components-library/static-1.14376",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "zustand": "/zustand/static-1.89",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3533",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2984",
  "navigation-components": "/navigation-components/static-1.19167",
  "nest": "/nest/static-1.709",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1472",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8134",
  "ui-universal-auth": "/ui-universal-auth/static-1.9744",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18680",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10901",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5484",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "audio-components": "/audio-components/static-1.6571",
  "FileManagerCore": "/FileManagerCore/static-1.40341",
  "FileManagerImages": "/FileManagerImages/static-1.37993",
  "video-components": "/video-components/static-1.14432",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1774",
  "purchase-motions-api": "/purchase-motions-api/static-1.6634",
  "signup-constants": "/signup-constants/static-1.19943",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "stylex-utils": "/stylex-utils/static-1.175",
  "usage-tracker-public": "/usage-tracker-public/static-1.7609",
  "reactive-lib": "/reactive-lib/static-1.1193",
  "simple-logging-lib": "/simple-logging-lib/static-1.3525",
  "nudge-client-utils": "/nudge-client-utils/static-1.3420",
  "chatspot-core": "/chatspot-core/static-1.23884",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7057",
  "cms-field-types": "/cms-field-types/static-1.5285",
  "content-icons-ui": "/content-icons-ui/static-1.2456",
  "integrations-lib": "/integrations-lib/static-1.17430",
  "underscore": "/underscore/static-1.8",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1158",
  "breeze-engine-core": "/breeze-engine-core/static-1.1458",
  "highlight.js": "/highlight.js/static-1.90",
  "markdown-it": "/markdown-it/static-1.6",
  "trellis-migration-context": "/trellis-migration-context/static-1.54",
  "nav-meta": "/nav-meta/static-1.30804",
  "commerce-permissions": "/commerce-permissions/static-1.1259",
  "customer-data-tracking": "/customer-data-tracking/static-1.7344",
  "products-iframe-lib": "/products-iframe-lib/static-1.8907",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11285",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2034",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2840",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.814",
  "calling-error-reporting": "/calling-error-reporting/static-1.31807",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11515",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7013",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2442",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6923",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10986",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "sales-views-client-types": "/sales-views-client-types/static-1.4731",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7366",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10419",
  "bark-lib": "/bark-lib/static-1.17005",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6369",
  "react-codemirror": "/react-codemirror/static-1.11116",
  "event-emitter": "/event-emitter/static-1.1436",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.485",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4335",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.624",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "data-agent-kit": "/data-agent-kit/static-1.916",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.460",
  "data-agent-utils": "/data-agent-utils/static-1.929",
  "fsm": "/fsm/static-1.4232",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-tinymce": "/react-tinymce/static-1.56270",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11049",
  "tinymce-config": "/tinymce-config/static-2.55396",
  "tinymce-plugins": "/tinymce-plugins/static-1.58510",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16005",
  "hubs-service-types": "/hubs-service-types/static-1.1742",
  "salesImages": "/salesImages/static-1.732",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3012",
  "user-context-client": "/user-context-client/static-1.4984",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.308",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1540",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.948",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4989",
  "video-embed": "/video-embed/static-1.36922",
  "social-insights-client-types": "/social-insights-client-types/static-1.22930",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3177",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3496",
  "whisper-core-api": "/whisper-core-api/static-1.7636",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14845",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6094",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8238",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10845",
  "rxjs": "/rxjs/static-5.10",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15844",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8093",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37219",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7271",
  "persist-promise": "/persist-promise/static-1.4179",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16669",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "trellis-story-utils": "/trellis-story-utils/static-1.4972",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.234",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57366",
  "hub-http-contrib": "/hub-http-contrib/static-1.3506",
  "tinymce-data": "/tinymce-data/static-1.41481",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5676",
  "layout-dnd-components": "/layout-dnd-components/static-1.13229",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12204",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16946",
  "academy-common-lib": "/academy-common-lib/static-1.15466",
  "outpost": "/outpost/static-1.4602",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3484",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9367",
  "ContentData": "/ContentData/static-1.69548",
  "layout-data-lib": "/layout-data-lib/static-1.10529",
  "academy-service-client": "/academy-service-client/static-1.4166",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4871",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7849",
  "wootric-nps": "/wootric-nps/static-1.7297",
  "advanced-menus-core": "/advanced-menus-core/static-1.15816",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12569",
  "ExportDialog": "/ExportDialog/static-6.10849",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35192",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15815",
  "simple-menus-lib": "/simple-menus-lib/static-1.17332",
  "settings-ui-lib": "/settings-ui-lib/static-1.13001",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11013",
  "immutable-less": "/immutable-less/static-1.5127",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8427",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4390",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8582",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1580",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4612",
  "simple-data-table": "/simple-data-table/static-1.3822"
}
};
